import { useAccess } from "src/hooks/useAccess.hook";
import editFill from "@iconify/icons-eva/edit-fill";
import deleteFill from "@iconify/icons-eva/trash-2-outline";
import viewFill from "@iconify/icons-eva/eye-fill";
import { ActionsMenu } from "../Actions/ActionsMenu";
import { useMutate } from "src/hooks/useFetch.hook";
import { getCompanyUrlId } from "src/react-query/endPoints";
import { useCallback, useMemo } from "react";
import { FEATURE } from "src/util/enums";
export const CompanyActionMenu = ({ id, row }) => {
  const isReadOnly = useAccess(FEATURE.COMPANY, "R");
  const hasEditAccess = useAccess(FEATURE.COMPANY, "U");
  // OCPI partners that exist only in ocpi_company_details have no company record to
  // disable, so delete does not apply to them.
  const hasDeleteAccess =
    useAccess(FEATURE.COMPANY, "D") && row?.linkedToCompany !== false;
  const { mutate } = useMutate("companyList");
  const onDelete = useCallback(() => {
    mutate({ url: getCompanyUrlId(id), method: "DELETE" });
  }, [id, mutate]);
  const actionList = useMemo(
    () => [
      {
        id: "view",
        title: "View",
        icon: viewFill,
        routerLink: `${id}`,
        hidden: !isReadOnly,
      },
      {
        id: "edit",
        title: "Edit",
        icon: editFill,
        routerLink: `${id}`,
        hidden: !hasEditAccess,
      },
      {
        id: "delete",
        title: "Delete",
        icon: deleteFill,
        action: onDelete,
        hidden: !hasDeleteAccess,
      },
    ],
    [id, isReadOnly, hasEditAccess, hasDeleteAccess, onDelete]
  );

  return <ActionsMenu menuList={actionList} />;
};
